import { ApiError } from '../../../../../shared/shared.api';
import { useCatalogue } from '../../../hooks/use-catalogue';
import { weightBandsApi } from '../weight-bands.api';

/** The form catches the range before it is sent; this is the backstop when the server's check says otherwise. */
function rangeMessage(err: ApiError): string | null {
  const issues = (err.body as { issues?: { path: string; message: string }[] } | null)?.issues ?? [];
  return issues.find((issue) => issue.path === 'maxKg')?.message ?? null;
}

export const useWeightBands = () =>
  useCatalogue(weightBandsApi, { conflictMessage: 'A weight band with this code already exists.', badRequestMessage: (err) => rangeMessage(err) });
